import { render, staticRenderFns } from "./synergy-active.vue?vue&type=template&id=28214a72&scoped=true"
import script from "./synergy-active.vue?vue&type=script&lang=js"
export * from "./synergy-active.vue?vue&type=script&lang=js"
import style0 from "./synergy-active.vue?vue&type=style&index=0&id=28214a72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28214a72",
  null
  
)

export default component.exports